import React from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Alert,
} from "@mui/material";

// Константа с сообщением
const PAYMENT_MESSAGE = "Для организации не подключен эквайринг. Внесите оплату через кассу.";

const DevicePage = () => {
  const { id } = useParams();

  return (
    <Container>
      <Typography variant="h4" align="center" gutterBottom sx={{ mt: 3 }}>
        Информация об устройстве
      </Typography>

      <Card sx={{ mb: 2, maxWidth: 600, mx: "auto" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            ID устройства: {id}
          </Typography>
          
          <Alert 
            severity="warning" 
            sx={{ 
              mt: 3,
              "& .MuiAlert-message": {
                fontSize: "1.1rem",
                fontWeight: "bold"
              }
            }}
          >
            {PAYMENT_MESSAGE}
          </Alert>
        </CardContent>
      </Card>
    </Container>
  );
};

export default DevicePage;